import { cn } from './lib/cn';

export type StatusKind =
  | 'ready'
  | 'progress'
  | 'review'
  | 'draft'
  | 'suspended'
  | 'exited';

const MAP: Record<StatusKind, { label: string; className: string; dot: string }> = {
  ready:     { label: 'Payroll-Ready',  className: 'bg-emerald-50 text-emerald-700 border-emerald-200', dot: 'bg-emerald-500' },
  progress:  { label: 'In Progress',    className: 'bg-amber-50 text-amber-700 border-amber-200',       dot: 'bg-amber-500' },
  review:    { label: 'Pending Review', className: 'bg-orange-50 text-orange-700 border-orange-200',    dot: 'bg-orange-500' },
  draft:     { label: 'Draft',          className: 'bg-slate-100 text-slate-600 border-slate-200',      dot: 'bg-slate-400' },
  suspended: { label: 'Suspended',      className: 'bg-transparent text-red-700 border-red-400',        dot: 'bg-red-500' },
  exited:    { label: 'Exited',         className: 'bg-slate-50 text-slate-600 border-slate-300',       dot: 'bg-slate-500' },
};

export function StatusChip({
  status,
  label,
  className,
}: {
  status: StatusKind;
  label?: string;
  className?: string;
}) {
  const m = MAP[status];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold',
        m.className,
        className
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', m.dot)} />
      {label ?? m.label}
    </span>
  );
}
